<template>
  <div>
    <div>
      <button type="button" class="btn btn--green my-3" @click="addLanguage()">{{ __('misc.add') }}
      </button>
    </div>
    <div class="row py-2 px-4 justify-content-between">
    <div
      class="form-group hrtcard shadow my-3 p-3 col-12 col-md-5"      
      v-for="(row, index_know_lang) in knowLanguages"
      v-bind:key="index_know_lang"
    >
      <div class="d-flex justify-content-end col-12 mb-2">
              <button
                type="button"
                class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-remove"
                @click="rmLanguage(index_know_lang)"
              >
              <i class="fas fa-trash"></i>
              </button>
        </div>      
      <div class="col-12 mb-1">
        <label>{{ __('forms.EvaluationChart.questions.questions_setting.question33.language') }}</label>
        <select
          class="form-control"
          :name="
            'question[' +
            question_id +
            '][know_language_data][' +
            index_know_lang +
            '][language]'
          "
        >
          <option value="">---</option>
          <option
            v-for="(lang, lang_index) in sortedLanguages"
            :value="lang.id"
            v-bind:key="lang_index"
          >
            {{ lang.name }}
          </option>
        </select>
      </div>
      <div class="col-12 mb-1">
        <label>{{ __('forms.LevelLanguages.name') }}</label>
        <select
          class="form-control"
          :name="
            'question[' +
            question_id +
            '][know_language_data][' +
            index_know_lang +
            '][level_language]'
          "
        >
          <option value="">---</option>
          <option
            v-for="(lang, index) in levels_languages"
            :value="lang.id"
            v-bind:key="index"
          >
            {{ lang.name }}
          </option>
        </select>
      </div>
      
      <div
        v-for="(element, index_element) in collection_know_languages_eavs"
        class="col-4"
        style="margin-top: 10px"
        v-bind:key="index_element"
      >
        <div>
          <label>{{ element.value }}</label>
          <div v-if="element.type == 'string'">
            <input
              v-if="element.key == 'duty_name'"
              required
              type="text"
              class="form-control"
              value=""
              :name="
                'question[' +
                question_id +
                '][know_language_data][' +
                index_know_lang +
                '][' +
                element.key +
                ']'
              "
            />
            <input
              v-else
              type="text"
              class="form-control"
              value=""
              :name="
                'question[' +
                question_id +
                '][know_language_data][' +
                index_know_lang +
                '][' +
                element.key +
                ']'
              "
            />
          </div>
          <div v-if="element.type == 'number'">
            <input
              type="number"
              class="form-control"
              value=""
              :name="
                'question[' +
                question_id +
                '][know_language_data][' +
                index_know_lang +
                '][' +
                element.key +
                ']'
              "
            />
          </div>
          <div v-if="element.type == 'date'">
            <input
              type="date"
              class="form-control"
              value=""
              :name="
                'question[' +
                question_id +
                '][know_language_data][' +
                index_know_lang +
                '][' +
                element.key +
                ']'
              "
            />
          </div>
          <div v-if="element.type == 'select'">
            <select
              class="form-control"
              :name="
                'question[' +
                question_id +
                '][know_language_data][' +
                index_know_lang +
                '][' +
                element.key +
                ']'
              "
            >
              <option
                v-for="(opt, index) in element.options"
                :value="index"
                v-bind:key="index"
              >
                {{ opt }}
              </option>
            </select>
          </div>
          <div v-if="element.type == 'radio' || element.type == 'radiobutton'">
            <div v-for="(opt, index) in element.options" v-bind:key="index">
              <input
                class="form-check-input"
                type="radio"
                :name="
                  'question[' +
                  question_id +
                  '][know_language_data][' +
                  index_know_lang +
                  '][' +
                  element.key +
                  ']'
                "
                :value="index"
              />
              <label class="form-check-label">
                {{ opt }}
              </label>
            </div>
          </div>
          <div v-if="element.type == 'checkbox'">
            <div v-for="(opt, index) in element.options" v-bind:key="index">
              <input
                class="form-check-input"
                type="checkbox"
                :name="
                  'question[' +
                  question_id +
                  '][know_language_data][' +
                  index_know_lang +
                  '][' +
                  element.key +
                  '][' +
                  index +
                  ']'
                "
                :value="index"
              />
              <label class="form-check-label">
                {{ opt }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  created() {},

  mounted() {},
  props: {
    languages: {
      type: Array,
      required: true,
    },
    levels_languages: {
      type: Array,
      required: true,
    },
    question_id: {
      type: Number,
      required: true,
    },
    collection_know_languages_eavs: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      knowLanguages: [],
    };
  },
  computed: {
    sortedLanguages() {
      return [...this.languages].sort((a, b) => a.name.localeCompare(b.name));
    },
  },
  methods: {
    rmLanguage(index) {
      this.knowLanguages.splice(index, 1);
    },
    addLanguage() {
      this.knowLanguages.push([]);
    },
  },
};
</script>
